import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import Modal from '~/commons/components/Modal.jsx';

const ModalConfirm = ({
  show,
  onReject = () => { },
  onConfirm = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onReject}
      centered
    >
      <div className="p-4">
        <h4 className="text-warning">
          <FA icon={faExclamationTriangle} size="lg" />
        </h4>
        <h6 className="mt-3">
          <strong>
            {t('DeleteSchool1')}
          </strong>
        </h6>
        <p>
          {t('DeleteSchool2')}
        </p>
        <h2>{t('Are you sure?')}</h2>
        <div className="form-row mt-4">
          <div className="col">
            <button
              className="btn btn-block btn-dark"
              onClick={onReject}
            >
              {t('Cancel')}
            </button>
          </div>
          <div className="col">
            <button
              className="btn btn-block btn-warning"
              onClick={onConfirm}
            >
              {t('Confirm')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
